/*eslint-disable */
import toast from '@/services/toast';
import { bus } from '@/main';
export default {
  name: 'plan-status-popup',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      firstStep:true,
      secondStep:false
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    closeFirstStepPopup(){
      this.firstStep = false
      this.secondStep = true
    },
    closePlanStatusChangePopup(){
      bus.$emit('allPlanClearStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    confirmPlanStatusChangePopup(){
      this.submitted = true
      this.$store.dispatch('allPlanClearFunc').then((res) => {
        toast.success('Subscription plan is all clear successfully');
        this.submitted =  false
        this.$store.dispatch('getSubscriptionPlanListFunc');
        this.closePlanStatusChangePopup();
      })
    }
  }
}